import React from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API, Badge, dayLabel, errText, longDate, propName, useHeaders, usePortal } from './kit';

const KEY = 'gcp_property';
export const CLIENT_REQUEST_KINDS = ['scheduling_request', 'new_clean_request', 'property_update', 'service_concern', 'intake_update', 'quote_decision'];
export const REQUEST_STATUS = {
  new: 'Pending review', in_review: 'In review', waiting: 'Waiting on details', withdrawn: 'Withdrawn',
  approved_awaiting_scheduling: 'Approved — awaiting scheduling', approved: 'Confirmed', declined: 'Declined', resolved: 'Resolved',
};
export const isOpenRequest = (r) => ['new', 'in_review', 'waiting'].includes(r.status);

// Selected property stays stable across pages (URL first, then this browser session)
export const useSelectedProperty = (properties) => {
  const [params, setParams] = useSearchParams();
  const list = properties || [];
  const wanted = params.get('property') || sessionStorage.getItem(KEY);
  const current = list.find((p) => p.id === wanted) || list.find((p) => p.is_primary) || list[0] || null;
  const select = (id) => { sessionStorage.setItem(KEY, id); const n = new URLSearchParams(params); n.set('property', id); setParams(n, { replace: true }); };
  return [current, select];
};

export const PropertyTabs = ({ properties, current, onSelect }) => (properties || []).length > 1 ? (
  <div className="tabs" role="group" aria-label="Select property" data-testid="property-tabs">
    {properties.map((p) => <button key={p.id} className={p.id === current?.id ? 'active' : ''} aria-pressed={p.id === current?.id} onClick={() => onSelect(p.id)} data-testid={`property-tab-${p.id}`}>{propName(p)}</button>)}
  </div>
) : null;

export const RequestList = ({ requests, properties, onChanged }) => {
  const headers = useHeaders();
  const { toast } = usePortal();
  const withdraw = async (r) => {
    if (!window.confirm('Withdraw this request? Your appointment is not changed.')) return;
    try { await axios.post(`${API}/api/review-items/${r.id}/withdraw`, {}, { headers }); toast('Request withdrawn. Your appointment is unchanged.'); onChanged(); } catch (e) { toast(errText(e)); }
  };
  if (!requests.length) return <div className="panel empty" data-testid="requests-empty">No requests yet. Any scheduling or new-clean requests will appear here.</div>;
  return requests.map((r) => {
    const prop = (properties || []).find((p) => p.id === r.address_id);
    return (
      <article className="panel" style={{ marginBottom: 15 }} key={r.id} data-testid={`request-${r.id}`}>
        <div className="section-top"><h2>{r.title}</h2><Badge testId={`request-status-${r.id}`}>{REQUEST_STATUS[r.status] || r.status}</Badge></div>
        <p>{prop ? `${propName(prop)} · ` : ''}Sent {dayLabel(r.created_at)}{r.requested_date && !(r.details || '').includes('Preferred date') ? ` · Preferred date: ${longDate(r.requested_date)}` : ''}</p>
        {r.details && <p style={{ whiteSpace: 'pre-wrap' }}>{r.details}</p>}
        {r.response && <div className="notice" data-testid={`request-response-${r.id}`}><strong>Your team replied{r.decided_at ? ` · ${dayLabel(r.decided_at)}` : ''}</strong><br />{r.response}</div>}
        {r.status === 'approved_awaiting_scheduling' && <p className="muted">Approved — your team will confirm the new appointment. Nothing has changed yet.</p>}
        {isOpenRequest(r) && <button className="text-button" onClick={() => withdraw(r)} data-testid={`request-withdraw-${r.id}`}>Withdraw this request</button>}
      </article>
    );
  });
};
